<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X711zA/tc-custom/9781612437699.jpg?1729185361901" alt="This image is the cover for the book Beyond Bullets"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beyond Bullets
      </h1>
      <p class="bookDescription body article font2">
        <b>Easy, inspiring suggestions for bullet journaling, a unique organizational tool to make your daily planning more productive and artistic. </b><br/><br/> Fun, colorful, and creative suggestions for the newest productivity phenomenon!<br/><br/> Going beyond basic tools, <i>BEYOND BULLETS</i> offers tips, tricks and creative ways to transform your notebook into a treasured life companion, including:<br/><br/> • Ornamental lettering<br/><br/> • Personalized habit trackers<br/><br/> • Colorful calendars<br/><br/> • Decorative headers<br/><br/> • Customized productivity lists<br/><br/> • Inspiring artwork<br/><br/> • Creative future logs<br/><br/> • Unique planning pages<br/><br/><i>BEYOND BULLETS</i> is the perfect guide to motivate beginners to start a daily journal routine, or for intermediate to advanced journalers to take their practice to the next level! 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Megan Rutell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?70202257